import { jsx as _jsx } from "react/jsx-runtime";
import DualCardEarnings from '../DualCardEarnings';
import PrivateCardEarnings from '../PrivateCardEarnings';
var EarningsCardType = function (_a) {
    var className = _a.className, cardType = _a.cardType, rewardsBalance = _a.rewardsBalance, earningsIcons = _a.earningsIcons;
    if (cardType === 'DUAL_CARD' && earningsIcons) {
        return (_jsx(DualCardEarnings, { earningsIcons: earningsIcons, className: className, rewardsBalance: rewardsBalance }));
    }
    if (cardType === 'PRIVATE_LABEL' && className === 'inside-drawer') {
        return _jsx(PrivateCardEarnings, { className: className });
    }
    return null;
};
export default EarningsCardType;
